import { DRAWABLE_TYPES } from './drawable-types'

/*
 * List of old rimboard types and new
 */
export const OLD_RIMBOARD_TYPES: DRAWABLE_TYPES[] = [DRAWABLE_TYPES.ROOF_SYSTEM, DRAWABLE_TYPES.FLOOR_SYSTEM]

export const NEW_RIMBOARD_TYPES: DRAWABLE_TYPES[] = [DRAWABLE_TYPES.ROOF_SYSTEMS, DRAWABLE_TYPES.FLOOR_SYSTEMS]
